import { render, staticRenderFns } from "./page-repo-manager.vue?vue&type=template&id=2bc91a74&scoped=true"
import script from "./page-repo-manager.vue?vue&type=script&lang=js"
export * from "./page-repo-manager.vue?vue&type=script&lang=js"
import style0 from "./page-repo-manager.vue?vue&type=style&index=0&id=2bc91a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc91a74",
  null
  
)

export default component.exports